import ProfileSettings from './profile-settings.vue'
export default ProfileSettings